import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';
import BtnExcel from '../../Components/BtnExcel';
import { useLocation } from 'react-router-dom';

import { 
  Layout,
  Col, 
  Row,
  Space,
  DatePicker,
  Input,
  Select,
} from 'antd';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { formatAmount, formatDate, getTodayDateISO } from '../../Utils/Common';

const { RangePicker } = DatePicker;
const { Search } = Input;
const { Option } = Select;

const RentalUnitHistory = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [excelData, setExcelData] = useState([])
  const [locationData, setLocationData] = useState([])
  const [pageSize, setPageSize] = useState('');
  const [filterConfig, setFilterConfig] = useState({
    search: location?.state?.property_name || '',
    type: '',
    rental_unit_id: location?.state ? location?.state?.id :  '',
    page: 1,
  })
  const [rentalData, setRentalData] = useState([])
  const [rentalHistoryData, setRentalHistoryData] = useState([])

  async function fetchRentalHistoryData() {
    setIsLoading(true);
    const response = await UseGetRequest("rental_units/get_rental_unit_history", filterConfig);
    if (response.data) {
      const rental_history = response?.data?.data?.map((data) => ({
        id: data.id,
        tenant_name: data.tenant_name,
        rental_name: data.rental_name,
        property_name: data.property_name,
        status: data.status,
        start_date: data.start_date,
        contact_no: data.contact_no,
        contract_sign_date: formatDate(data.contract_sign_date),
        contract_end_date: formatDate(data.contract_end_date),
        lease_term: data.lease_term,
        space_rental_rate: formatAmount(data.space_rental_rate),
        preterminate_date:  formatDate(data.preterminate_date),
      }))
      setPageSize(response?.data?.size)
      setRentalHistoryData(rental_history);
    } else {
      setRentalHistoryData([])
    }

    setIsLoading(false);
  }

  async function fetchExportData() {
    setExportLoading(true);

    const response = await UseGetRequest("rental_units/get_rental_unit_history",
      {
        search: filterConfig.search,
        type: filterConfig.type,
        rental_unit_id: filterConfig.rental_unit_id,
      }
    );
    if (response.data) {
      const excel = response?.data?.data?.map((data) => ({
        id: data.id,
        tenant_name: data.tenant_name,
        rental_name: data.rental_name,
        property_name: data.property_name,
        status: data.status,
        start_date: data?.start_date ? formatDate(data?.start_date) : "",
        contract_sign_date: formatDate(data.contract_sign_date),
        contract_end_date: formatDate(data.contract_end_date),
        lease_term: data.lease_term,
        space_rental_rate: formatAmount(data.space_rental_rate),
        preterminate_date: data.preterminate_date ? formatDate(data.preterminate_date) : "",
        contact_no: data.contact_no,      
      }))
      setExcelData(excel)
      setExportLoading(false);
    } else {
      setExcelData([])
      setExportLoading(false);
    }

  }

  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      page_size: pagination.pageSize
      // total_records_per_page: pagination.pageSize,
    }));
  };

  async function fetchRentalData() {

    const response = await UseGetRequest("rental_units/get");
    if (response?.data) {
      setRentalData(response?.data?.data);
    } else {
      setRentalData([])
    }

  }

  const handleRentalUnit = (rental_id) => {
    const filter_data = rentalData.filter((item) => item.id === rental_id)
    setFilterConfig((prev) => (
      {
        ...prev,
        rental_unit_id: rental_id,
      }
    ));
    setLocationData(filter_data[0])

  }

  const handleSearchChange = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        search: e || '',
        rental_unit_id: '',
        page: 1,
      }
    ));
  };
  
  const handleEmpty = (e) => {
    if(e.target.value === ''){
      setFilterConfig((prev) => (
        {
          ...prev,
          search: e?.target?.value || '',
          rental_unit_id: '',
          page: 1,
        }
      ));
    }
  };

  const onSearchDate = (e) => {
   if(e){
    setFilterConfig((prev) => (
      {
        ...prev,
        start_date: e[0].format("YYYY-MM-DD"),
        end_date: e[1].format("YYYY-MM-DD"),
        rental_unit_id: '',
        page: 1,
      }
    ));
   } else {
    setFilterConfig((prev) => (
      {
        ...prev,
        start_date: '',
        end_date: '',
        rental_unit_id: '',
        page: 1,
      }
    ));
   }

  };

  useEffect(() => {
    fetchRentalData();
    fetchExportData();
    fetchRentalHistoryData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  return (
    <Layout className='page'>
      <Navbar navKey={'unit_history_nav'}/>
      <Layout className='content-container'>
        <Row className='custom-padding responsive-inline responsive-tab-inline'>
          <Col span={12} className='header-container'>
            RENTAL UNIT HISTORY
          </Col>
          <Col span={12} className=' responsive-tab-width' align='end'>
            <Space className='responsive-inline'>
              <BtnExcel
                label={"Export to Excel"}
                size={"sm"}
                excelData={excelData}
                xlsxHeaders={[
                  "ID",
                  "Tenant Name",
                  "Rental Name",
                  "Property Name",
                  "Status",
                  "Start Date",
                  "Contract Start",
                  "Contract End",
                  "Lease Term",
                  "Space Rental Rate",
                  "Pre-terminated Date",
                  "Contact Number",
                ]}
                handleData={fetchExportData}
                isClicked={exportLoading}
                fileName={`${getTodayDateISO()}_Rental_Unit_History.xlsx`}
              />
            </Space>
          </Col>
        </Row>
        <Row>
          <Space className='responsive-inline excel-row'>          
            <Search
              value={location?.state?.property_name ? filterConfig?.search : undefined} 
              placeholder="Search..."
              size='medium'
              allowClear
              onSearch={(e)=>handleSearchChange(e)}
              onChange={(e)=>handleEmpty(e)}
              className='responsive-header-input'
            />  

            <Select 
              placeholder="Select a Rental Unit" 
              onChange={(e) => handleRentalUnit(e)}
              className='select-field responsive-header-input'
              showSearch
              allowClear
              align='left'
              value={locationData?.name}
              filterOption={(input, option) =>
                  option?.children?.toLowerCase().includes(input.toLowerCase())
              }
            >
              {rentalData.map((option) => (
                  <Option key={option.id} value={option.id}>{option.name}</Option>
              ))}
            </Select>

            <RangePicker 
              renderExtraFooter={() => 'extra footer'} 
              className='responsive-header-input'
              onChange={(e)=>onSearchDate(e)}
            />       
          </Space>
        </Row>
        <Row className='page-content'>
          <Col span={24} className='responsive-overflow-auto'>
            <AntDTable
                tableHeaders={[
                "Property Building",
                "Unit Number",
                "Tenant Name",
                "Contact Number",
                "Status",
                "Lease Term",
                "Contract Start",
                "Contract End",
                "Rental Rate",
                ]}
                headerSelector={[
                "property_name",
                "rental_name",
                "tenant_name",
                "contact_no",
                "status",
                "lease_term",
                "contract_sign_date",
                "contract_end_date",
                "space_rental_rate",
                ]}
                tableData={rentalHistoryData}
                withAction={false}
                loading={isLoading}
                tablePages={10}
                handleTableChange={handleTableChange}
                filterConfig={filterConfig}
                totalSize={pageSize}
                isSearch={true}
            />
          </Col>
        </Row>
      </Layout>
    </Layout>
  )
}

export default RentalUnitHistory
